import { Component, OnInit } from '@angular/core';
import {LoaderService} from "../../services/loader.service";
import { Subject } from 'rxjs';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
@Component({
    selector: 'core-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  color = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  diameter = 24;
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
  }

}
